import React from 'react';
import { Typography, Divider } from 'antd';
import team1 from '../../../Assets/ResearchLabs/SDSSL/Team/SDSSL-Team-1.jpg';
import team2 from '../../../Assets/ResearchLabs/SDSSL/Team/SDSSL-Team-2.jpg';
import team3 from '../../../Assets/ResearchLabs/SDSSL/Team/SDSSL-Team-3.jpg';
import team4 from '../../../Assets/ResearchLabs/SDSSL/Team/SDSSL-Team-4.jpg';
import team5 from '../../../Assets/ResearchLabs/SDSSL/Team/SDSSL-Team-5.jpg';
import team6 from '../../../Assets/ResearchLabs/SDSSL/Team/SDSSL-Team-6.jpg';
import team7 from '../../../Assets/ResearchLabs/SDSSL/Team/SDSSL-Team-7.jpg';
import team8 from '../../../Assets/ResearchLabs/SDSSL/Team/SDSSL-Team-8.jpg';
import team9 from '../../../Assets/ResearchLabs/SDSSL/Team/SDSSL-Team-9.jpg';
import team10 from '../../../Assets/ResearchLabs/SDSSL/Team/SDSSL-Team-10.jpg';
import team11 from '../../../Assets/ResearchLabs/SDSSL/Team/SDSSL-Team-11.png';
import team12 from '../../../Assets/ResearchLabs/SDSSL/Team/SDSSL-Team-12.png';
import '../../../Styles/ResearchLabs.css';

const { Title } = Typography;

const members = [
  { name: 'Dr. Shafi Ullah', image: team1 },
  { name: 'Dr. Jan Muhammad', image: team2 },
  { name: 'Ms. Penha Tahir', image: team3 },
  { name: 'Mr. Syed Ahmed Shah', image: team4 },
  { name: 'Mr. Niamat Ullah', image: team5 },
  { name: 'Mr. Muhammad Amjad', image: team6 },
  { name: 'Mr. Syed Muhammad Khalid', image: team7 },
  { name: 'Ms. Bibi Ayesha Kasi', image: team8 },
  { name: 'Mr. Shahzaib Khan', image: team9 },
  { name: 'Dr. Bakhtiyar Khan', image: team10 },
  { name: 'Dr. Syed Atiq Shah', image: team11 },
  { name: 'Dr. Faisal Ahmad Khan', image: team12 },
];

const OurTeamSection = () => (
  <section className="sdssl-team-section">
    <div className="sdssl-team-inner">
      <Title level={2} className="sdssl-team-title">Our Team</Title>
      <Divider className="ncgsa-divider" />
      <div className="sdssl-team-grid">
        {members.map((member) => (
          <article className="sdssl-team-card" key={member.name}>
            <img src={member.image} alt={member.name} className="sdssl-team-photo" />
            <h3 className="sdssl-team-name">{member.name}</h3>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default OurTeamSection;
